import React from "react";
import { Check } from "lucide-react";
import Modal from "./Modal";
import { SUBSCRIPTION_PLANS } from "../../const/subscriptionPlan";
import { CREDIT_TOPUP_PACKS } from "../../const/creditTopUpPacks";

const UpgradeModal = ({ isOpen, onClose, onUpgrade, isPremium, hasActiveSubscription }) => {
	const showTopUps = hasActiveSubscription === true;

	const handleSubscribe = () => {
		onUpgrade(SUBSCRIPTION_PLANS.PREMIUM);
	};

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			title={showTopUps ? "Top Up Credits" : "Unlock User Potential"}
		>
			<div className="flex flex-col gap-6">
				<div className="text-center">
					<p className="text-gray-600 mb-4">
						{showTopUps
							? "Purchase a one-time credit pack. 1 credit unlocks 1 unique chart with full interpretations and included reports. Top-up credits expire when your subscription ends."
							: "Upgrade to our Professional plan to access advanced heliocentric astrology features."}
					</p>
					{!showTopUps && (
						<div className="flex justify-center items-baseline mb-2">
							<span className="text-4xl font-bold text-gray-900">$49.99</span>
							<span className="text-gray-500 ml-1">/month</span>
						</div>
					)}
				</div>

				{showTopUps ? (
					<div className="grid grid-cols-1 gap-3">
						{CREDIT_TOPUP_PACKS.map((pack) => (
							<button
								key={pack.planType}
								type="button"
								onClick={() => onUpgrade(pack.planType)}
								className="w-full py-3 px-4 rounded-lg border-2 border-indigo-200 bg-white hover:border-indigo-600 hover:bg-indigo-50 transition-all text-left flex items-center justify-between"
							>
								<span className="font-semibold text-gray-900">{pack.label}</span>
								<span className="font-bold text-indigo-600">${pack.price.toFixed(2)}</span>
							</button>
						))}
					</div>
				) : (
					<>
						<div className="bg-indigo-50 rounded-xl p-4">
							<h4 className="font-semibold text-indigo-900 mb-3">What's Included:</h4>
							<ul className="space-y-3">
								<li className="flex items-center text-gray-700">
									<Check size={18} className="text-indigo-600 mr-2 flex-shrink-0" />
									<span>Unlimited Chart Calculations</span>
								</li>
								<li className="flex items-center text-gray-700">
									<Check size={18} className="text-indigo-600 mr-2 flex-shrink-0" />
									<span>Full Planetary & Aspect Interpretations</span>
								</li>
								<li className="flex items-center text-gray-700">
									<Check size={18} className="text-indigo-600 mr-2 flex-shrink-0" />
									<span>30 Credits / Month (1 credit = 1 Interpretation)</span>
								</li>
								<li className="flex items-center text-gray-700">
									<Check size={18} className="text-indigo-600 mr-2 flex-shrink-0" />
									<span>Transit Reports</span>
								</li>
							</ul>
						</div>

						<div className="flex flex-col gap-3">
							<button
								onClick={handleSubscribe}
								className="w-full py-3 px-6 rounded-lg font-bold text-white bg-indigo-600 hover:bg-indigo-700 shadow-md transition-all duration-200"
							>
								Subscribe Now ($49.99)
							</button>
						</div>
					</>
				)}

				<button
					onClick={onClose}
					className="w-full py-3 px-6 rounded-lg font-semibold text-gray-500 hover:text-gray-700 hover:bg-gray-100 transition-colors"
				>
					Maybe Later
				</button>
			</div>
		</Modal>
	);
};

export default UpgradeModal;
